import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  keyword: string;
  onSearch: (keyword: string) => void;
}

export default function Header({ keyword, onSearch }: HeaderProps) {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(keyword);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleInput = (value: string) => {
    setInputValue(value);
    // 防抖 300ms
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onSearch(value);
    }, 300);
  };

  return (
    <div
      className="bg-white sticky top-0 z-40"
      style={{ boxShadow: "0 1px 0 #F3F4F6" }}
    >
      <div className="px-4 pb-3 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 24px)" }}>
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
          style={{ background: "#F3F4F6" }}
        >
          <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#374151" }} />
        </button>
        <div className="flex-1 rounded-xl px-3 py-2 flex items-center gap-2" style={{ background: "#F3F4F6" }}>
          <i className="ri-search-line" style={{ color: "#9CA3AF", fontSize: 15 }} />
          <input
            type="text"
            value={inputValue}
            onChange={(e) => handleInput(e.target.value)}
            placeholder="搜索线路名称、目的地..."
            className="flex-1 text-sm bg-transparent outline-none placeholder-gray-400"
          />
          {inputValue && (
            <button onClick={() => { setInputValue(""); onSearch(""); }} className="cursor-pointer">
              <i className="ri-close-circle-fill" style={{ color: "#9CA3AF", fontSize: 16 }} />
            </button>
          )}
        </div>
        <button className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0" style={{ background: "#F3F4F6" }}>
          <i className="ri-equalizer-2-line" style={{ color: "#6B7280", fontSize: 18 }} />
        </button>
      </div>
    </div>
  );
}
